import { Redirect, Slot, usePathname, type Href } from "expo-router";

import { ControlAccessProvider, useControlAccessContext } from "@/src/control/ControlAccessContext";
import { ControlAccessGate } from "@/src/control/ControlAccessGate";
import { ControlShell } from "@/src/control/ControlShell";

export default function ControlLayout() {
  return <ControlAccessProvider><ControlLayoutContent /></ControlAccessProvider>;
}

function ControlLayoutContent() {
  const access = useControlAccessContext();
  const pathname = usePathname();
  const isDeniedRoute = pathname === "/control/access-denied";
  if (access.status === "unauthenticated") return <Redirect href="/(auth)/login" />;
  if (access.status === "email_verification_required") return <Redirect href={"/(auth)/verify-email" as Href} />;
  if ((access.status === "forbidden" || access.status === "disabled") && !isDeniedRoute) {
    return <Redirect href={`/control/access-denied?reason=${access.status}` as Href} />;
  }
  if (isDeniedRoute) return <Slot />;
  return <ControlAccessGate><ControlShell><Slot /></ControlShell></ControlAccessGate>;
}
